import { render, staticRenderFns } from "./HospitalizationHistorySelectorDialog.vue?vue&type=template&id=3c32bfe3&scoped=true&"
import script from "./HospitalizationHistorySelectorDialog.vue?vue&type=script&lang=ts&"
export * from "./HospitalizationHistorySelectorDialog.vue?vue&type=script&lang=ts&"
import style0 from "./HospitalizationHistorySelectorDialog.vue?vue&type=style&index=0&id=3c32bfe3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c32bfe3",
  null
  
)

export default component.exports